import { EEstimationTargets } from '@cian/valuation-main-filters-widget';
import { useIsDesktop } from '@cian/valuation-utils-component';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { selectFilters } from '../../../selectors/selectFilters';
import { checkHasData, useEstimationHistoryQuery } from '../../../serverState/estimationHistory';

interface IParams {
  isSubmit?: boolean;
}

export function useButtonText({ isSubmit }: IParams = {}): string {
  const isDesktop = useIsDesktop();
  const { estimationTarget } = useSelector(selectFilters);
  const { data } = useEstimationHistoryQuery();
  const hasPrevEstimations = React.useMemo(() => checkHasData(data), [data]);

  const isNewbuildingValuation = estimationTarget === EEstimationTargets.newbuilding;

  if (isSubmit) {
    if (isNewbuildingValuation) {
      return isDesktop ? 'Оценить' : 'Оценить ЖК';
    }

    return 'Оценить';
  }

  if (!isDesktop) {
    if (hasPrevEstimations) {
      return 'Оценить другой объект';
    }

    return 'Перейти к оценке';
  }

  /* istanbul ignore next */
  return 'Оценить';
}
